import { useState } from "react";
import { mockReferralLinks, mockResellerUser } from "@/mocks/reseller";

const platformIcon: Record<string, string> = {
  TikTok: "ri-tiktok-line",
  Instagram: "ri-instagram-line",
  Douyin: "ri-tiktok-line",
  YouTube: "ri-youtube-line",
  WeChat: "ri-wechat-line",
};

const platformColor: Record<string, string> = {
  TikTok: "bg-gray-900 text-white",
  Instagram: "bg-pink-100 text-pink-700",
  Douyin: "bg-gray-900 text-white",
  YouTube: "bg-red-100 text-red-700",
  WeChat: "bg-green-100 text-green-700",
};

const ReferralLinksPanel = () => {
  const [copied, setCopied] = useState<string | null>(null);

  const handleCopy = (url: string, id: string) => {
    navigator.clipboard.writeText(url).then(() => {
      setCopied(id);
      setTimeout(() => setCopied(null), 2000);
    });
  };

  return (
    <div className="bg-white rounded-xl border border-gray-100 overflow-hidden">
      <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100">
        <h2 className="font-bold text-gray-900 text-sm">My Referral Links</h2>
        <div className="flex items-center gap-2 bg-[#D4AF37]/10 px-3 py-1.5 rounded-full">
          <i className="ri-links-line text-[#B8860B] text-xs"></i>
          <span className="text-xs font-semibold text-[#B8860B]">Code: {mockResellerUser.referralCode}</span>
        </div>
      </div>
      <div className="divide-y divide-gray-50">
        {mockReferralLinks.map((link) => (
          <div key={link.id} className="px-5 py-4">
            <div className="flex items-start justify-between gap-4 mb-3">
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-gray-900 text-sm truncate">{link.product}</div>
                <div className="text-xs text-gray-400 mt-0.5">{link.factory}</div>
              </div>
              <span className={`flex items-center gap-1 text-[10px] font-semibold px-2 py-1 rounded-full whitespace-nowrap ${platformColor[link.platform] || "bg-gray-100 text-gray-700"}`}>
                <i className={platformIcon[link.platform] || "ri-share-line"}></i>
                {link.platform}
              </span>
            </div>
            <div className="flex items-center gap-2 bg-gray-50 rounded-lg px-3 py-2 mb-3">
              <span className="text-xs text-gray-500 flex-1 truncate font-mono">{link.url}</span>
              <button
                onClick={() => handleCopy(link.url, link.id)}
                className="flex items-center gap-1 text-xs font-semibold text-[#C41E3A] hover:text-[#a01830] transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className={copied === link.id ? "ri-check-line" : "ri-file-copy-line"}></i>
                {copied === link.id ? "Copied!" : "Copy"}
              </button>
            </div>
            <div className="grid grid-cols-3 gap-3">
              <div className="text-center">
                <div className="text-sm font-bold text-gray-900">{link.clicks.toLocaleString()}</div>
                <div className="text-[10px] text-gray-400">Clicks</div>
              </div>
              <div className="text-center border-x border-gray-100">
                <div className="text-sm font-bold text-gray-900">{link.sales}</div>
                <div className="text-[10px] text-gray-400">Sales</div>
              </div>
              <div className="text-center">
                <div className="text-sm font-bold text-[#C41E3A]">${link.earned.toLocaleString()}</div>
                <div className="text-[10px] text-gray-400">{link.commission}% comm.</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReferralLinksPanel;
